(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("ResetPasswordCtrl", ["accountsResource", "$scope", "profileRecord", "REG_EXP", "messageService", resetPasswordCtrl]);
    function resetPasswordCtrl(accountsResource, $scope, profileRecord, REG_EXP, messageService) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.profileRecord = profileRecord;
        vm.passwordPattern = REG_EXP.password;
        //Check if password has special characters that are not allowed
        vm.checkSpecialCharacter = function (password) {
            if (password)
                return REG_EXP.specialCharacterPassword.test(password);
            return false;
        };
        vm.save = function (isValid) {
            vm.saving = true;
            if (isValid) {
                var model = { newPassword: vm.newPassword, ConfirmPassword: vm.confirmPassword };
                accountsResource.resetAccountPassword({ personSeq: vm.profileRecord.personSeq }, model, function (result) {
                    messageService.success("account.profile.edit.resetPassword.success");
                    $scope.$close(result);
                }, function (errorData) {
                    vm.saving = false;
                    messageService.error(errorData);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
